const createSystem = {
  createSystem: {
    selectSystem:
      'Wählen Sie ein System aus, für das Sie den Entwurfsprüfungsdienst in Anspruch nehmen möchten:',
    residential: 'Wohnimmobilien',
    commercial: 'Gewerblich',
    selectfromList:
      'Wählen Sie aus einer Liste von bereits in Enlighten erstellten Systemen',
    enterSystemName: 'Bitte geben Sie den Systemnamen ein',
    siteSelectionErrorMsg1: 'Sie haben ein ',
    siteSelectionErrorMsg2: ' System ausgewählt. Bitte wählen Sie das ',
    siteSelectionErrorMsg3: ' System aus, um fortzufahren.',
    commercialErrorMsg: 'Gewerbliches',
    residentialErrorMsg: 'Wohnimmobilien',
    createNewSystem: 'Erstellen Sie ein neues System in Enlighten',
    systemName: 'Name des Systems',
    type: 'Typ',
    thirdParty: 'Im Besitz Dritter (z.B.: PPA oder geleast)',
    siteInformation: 'Systemdaten',
    collapse: 'Zusammenklappen',
    expand: 'Ausklappen',
    customerName: 'Customer Name',
    address: 'Adresse',
    zipCode: 'Postleitzahl',
    noOfMicroinverters: 'Anzahl der Mikrowechselrichter',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    enlightenVersion: 'Version aufklären',
    myEnlighten: 'MyEnlighten',
    monitoring:
      'Der Besitzer erhält MyEnlighten zur Überwachung der Systemleistung.',
    location: 'Standort',
    streetAddress1: 'Straße und Hausnummer 1',
    streetAddress2: 'Straße und Hausnummer 2',
    required: 'Erforderlich',
    zipCodePostal: 'Postleitzahl',
    country: 'Land',
    owner: 'Eigentümer',
    state: 'Staat/Provinz',
    city: 'Stadt',
    deviceDetails: 'Gerätedetails',
    enphaseGuideLine:
      'Enphase stellt Anleitungen und Ressourcen zur Verfügung, um Installateure bei der Planung eines Systems innerhalb geeigneter Parameter zu unterstützen. Der Installateur und qualifizierte Elektriker sind für das endgültige Design und die Umsetzung verantwortlich.',
    confirm: 'Ich bestätige das Folgende',
    authorized:
      'Ich bin befugt, mich im Namen des Systemeigentümers/Hosts für Enlighten zu registrieren, der mir die Erlaubnis erteilt hat, diese Informationen in seinem Namen an Enphase zu übermitteln.',
    readUnderstand: 'Ich habe die Enphase Richtlinien gelesen und verstanden',
    privacyPolicy: 'Datenschutzrichtlinie',
    and: 'und',
    terms: 'Nutzungsbedingungen',
    policy: 'die „Richtlinien“',
    agreedForTerms1: 'Ich habe die',
    agreedForTerms2:
      'für Enphase Design Review Services gelesen und bin damit einverstanden.',
    termsAndCondition: 'Allgemeinen Geschäftsbedingungen',
    acknowledge:
      '	Der Systembesitzer/Host hat bestätigt, dass er die Richtlinien gelesen und sie versteht.',
    informedSystemOwner:
      'Ich habe dem Systembesitzer/Host mitgeteilt, dass mein Unternehmen in der Lage sein wird, ihre Energieverbrauchsmengen und -zeiten zu überwachen und dass sie diese Erlaubnis jederzeit widerrufen können',
    proceedCreateSystem: 'Ohne Verknüpfung/Erstellung eines Systems fortfahren',
    cancel: 'Abbrechen',
    noOption: 'Keine Optionen',
    invalidPhoneNumber: 'Ungültige Telefonnummer',
    invalidEmail: 'Ungültige E-Mail',
    australia: 'Australien',
    usa: 'Vereinigte Staaten',
    germany: 'Deutschland',
    belgium: 'Belgien',
    austria: 'Österreich',
    netherlands: 'Niederlande',
    france: 'Frankreich',
    switzerland: 'Schweiz',
  },
};

export default createSystem;
